import { createSelector } from 'reselect'
import { currentUser } from 'app/modules/user/selectors'
import { inboxOptions } from 'app/modules/inbox/selectors'
import { root } from './selectors'
import { parseBotCampaign } from './models'

export const rootUI = createSelector(
  root,
  (root) => root.get('ui')
)

export const query = createSelector(
  rootUI,
  (rootUI) => rootUI.get('query', "")
)

export const draft = createSelector(
  rootUI,
  inboxOptions,
  currentUser,
  (rootUI, inboxOptions, currentUser) => {
    return rootUI.get('draft', parseBotCampaign({
      inboxId: !!inboxOptions && inboxOptions.size > 1 && inboxOptions.valueSeq().first().get('value'),
      attributes: { senderId: currentUser.id }
    }))
  }
)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/campaigns/selectorsUI.js